<template>
    <div class="main-body">

        <select-import-template
            v-on:processDataClicked="processCsv"
            :fields-list="fieldsList"
            :date-fields="dateFields"
            type="users"
            title-string="import_users_page.title"
            import-button-string="import_users_page.process_button"
        />

        <div class="row">
            <div class="col">
                <div v-text="t('import_users_page.total_in_file')"/>:
                <span v-text="importData.length"></span>
            </div>
            <div class="col">
                <div v-text="t('import_users_page.ready_to_import')"/>
                :
                <span v-text="readyToImport.length"></span>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div v-text="t('import_users_page.imported')"/>
                :
                <span v-text="imported.length"></span>
            </div>
            <div class="col">
                <div v-text="t('import_users_page.imported_errors')"/>
                :
                <span v-text="importFailed.length"></span>
            </div>
        </div>

        <DGTableWrapper class="table-wrapper"
                        style="height: 250px"
                        ref="dgtableWrapper_users"
                        :cell-formatter="cellFormatter"
                        :columns="columnsDef"
                        :on-header-context-menu="onHeaderContextMenu"
                        :on-row-create="onRowCreate"
                        :on-header-row-create="onHeaderRowCreate"
                        :rows="tableData"/>

        <button
            :disabled="importing || !readyToImport.length"
            @click="importUsers()"
            class="positive-button"
        >{{t('import_users_page.import_button')}}</button>

        <button
            @click="stopImportClick"
            :disabled="!importing"
            class="neutral-button"
        >{{t('import_users_page.stop_import')}}</button>

    </div>
</template>
<script>

import i18n, {t} from '../../i18n/i18n.js';
import app from '../../App.js';
import axios from 'axios';
import MessagePopupView from '../../../controls/MessagePopupView.js';
import {USER_BASIC_FIELDS} from "../../../Globals";
import SelectImportTemplate from '../contacts/ImportContactVue/components/SelectImportTemplate.vue';
import DGTableWrapper from '../contacts/ImportContactVue/components/DGTableWrapper.vue';
import * as PapaParse from 'papaparse';

const TemplateField = function (label, sampleValue, field, format) {
    this.label = label;
    this.sampleValue = sampleValue;
    this.field = field;
    this.format = format;
};

const postUser = user => {
    const userId = user.id
    const apiUrl = app.apiUrl('users' + (!!userId ? `/${userId}` : ''));

    return axios.post(apiUrl, user);
}

export default {
    components: {SelectImportTemplate, DGTableWrapper},
    data() {
        return {
            importData: [],
            ignoreDuplicates: false,
            importProgress: undefined,
            duplicateFieldSettings: app.getUserSetting('users_import_field_settings') || {},
            importedDuplicates: [],
            selectedFile: '',
            fields: [new TemplateField()],
            showTemplatePopup: false,
            users: [],
            teams: [],
            projects: [],
            importing: false,
            stopImport: false,
            imported: [],
            importFailed: [],
            parsedFailed: [],
        }
    },

    beforeDestroy() {
        this.stopImport = true;
    },

    methods: {

        async processCsv(file, templateId, ignoreDuplicates, templateData) {

            this.importData = [];
            this.importedDuplicates = [];
            this.imported = [];
            this.importFailed = [];
            this.parsedFailed = [];

            try {
                app.AlertUI.showLoader();

                const {columns} = JSON.parse(templateData.template);

                let headerParsingError = false;

                PapaParse.parse(file, {
                    header: true,
                    transformHeader: (header) => {
                        try {
                            return columns.find(col => col.label === header).name;
                        } catch (err) {
                            headerParsingError = true;
                        }

                    },
                    complete: (results) => {
                        if (headerParsingError) {
                            return new MessagePopupView({addClass: 'error', message: this.t('import_users_page.errors.template_mismatch'), queue: true}).show();
                        }
                        this.importData = results['data'];
                        if (this.importData && this.importData.length) {
                            this.getUsersData();
                        }
                    },
                    error(error, file) {
                        console.log(error)
                    }
                });

            } catch (err) {
                app.showReqError(err);
            } finally {
                app.AlertUI.hideLoader();
            }

        },

        stopImportClick() {
            this.stopImport = true;
            this.refreshTable();
        },

        async getUsersData() {
            try {
                const requests = [axios.get(app.apiUrl('users')), axios.get(app.apiUrl('teams')), axios.get(app.apiUrl('projects'))];
                const [{data: users}, {data: teams}, {data: projects}] = await Promise.all(requests);
                this.users = users;
                this.teams = teams;
                this.projects = projects;
            } catch (err) {
                app.showReqError(err);
            }
        },

        async importUsers() {

            this.importing = true;

            for (const [index, user] of this.tableData.entries()) {

                if (this.stopImport) {
                    this.importing = false;
                    return;
                }

                if (user.errors.length) {
                    user.result = 'skipped';
                    continue;
                }

                try {
                    await postUser(this.importData[index]);
                    user.result = 'success';
                    this.imported.push(this.importData[index])
                } catch(err) {
                    console.error('post error:', user, err);
                    user.result = err.toString();
                    this.importFailed.push(this.importData[index]);
                }

                //const delay = ms => new Promise(res => setTimeout(res, ms));
                //await delay(2000);

            }
            this.importing = false;
            this.importCompleted(this.imported.length);
        },

        importCompleted (newUsersCount) {

            this.refreshTable();

            new MessagePopupView({
                addClass: 'done', message: t('import_users_page.completed_prompt', {count: newUsersCount}), queue: true
            }).show();


        },

        refreshTable() {
            this.$refs['dgtableWrapper_users'].refreshRows();
        },

        cellFormatter (val, colName) {
            if (colName === 'rowType') {
                return t('import_users_page.column_types')[val];
            }
            if (colName === 'password') {
                return '*'.repeat(val && val.length);
            } else if (this.phoneFieldsSet.has(colName)) {
                return PhoneNumberUtil.displayPhoneNumber(val || '');
            } else if (this.dateFields.includes(colName)) {
                return val ? i18n.formatDate(val, t('date_formats.normal_date')) : '';
            } else if (colName === 'team_id') {
                const foundTeam = this.teams.find(team => team.id === val);
                return foundTeam && foundTeam.name || (val || '');
            } else if (colName === 'errors') {
                return val.map(x => t('import_users_page.errors')[x]).join(', ');
            } else if (colName === 'result') {
                return t('import_users_page.result')[val];
            }
            return val;
        }

    },

    computed: {
        fieldsList() {
            return USER_BASIC_FIELDS
                .map(field => ({
                        value: field,
                        text: t('user_fields', field)
                    })
                );
        },
        dateFields() {
            return ['birthdate', 'job_start'];
        },
        dateFieldsSet() {
            return new Set(this.dateFields);
        },
        phoneFieldsSet() {
            return new Set(['phone', 'phone2']);
        },
        columns() {
            if (!this.importData || this.importData.length === 0)
                return [];

            const keys = Object.keys(this.importData[0]);

            const results = keys.map(fieldKey => {
                let fieldName = t(`user_fields.${fieldKey}`);

                const fieldObject = {
                    name: fieldKey,
                    label: fieldName,
                };

                if (this.phoneFieldsSet.has(fieldKey)) {
                    fieldObject.cellClasses = 'ltr';
                }

                return fieldObject;
            });

            results.unshift({
                name: 'rowType',
                label: t('import_users_page.columns.type'),
            })

            results.push({
                name: 'errors',
                label: t('import_users_page.columns.errors'),
            }, {
                name: 'result',
                label: t('import_users_page.columns.result'),
            });

            return results;
        },
        columnsDef() {
            return this.columns.map(col => {
                return {
                    ...col,
                    sortable: true,
                    searchable: true,
                }
            })
        },
        tableData() {
            const users = this.users;

            if (!users.length ||
                !this.importData.length) return [];

            return this.importData.map(row => {

                const {id, username, password, team_id: teamId, project_id: projectId} = row;

                const tableRow = Object.assign({errors: [], result: ''}, row)

                if (!username && !id) {
                    tableRow.errors.push('missing_required_fields');
                }

                const updateUser = users.find(user => String(user.id) === id);
                const duplicateUser = users.find(user => user.username === username);

                if (id && !updateUser) { // If the new user has an id field - it must already exist
                    tableRow.errors.push('id_not_found');
                }

                if (!updateUser && duplicateUser) {
                    tableRow.errors.push('username_already_exist');
                }

                if (teamId) {
                    const foundTeamById = this.teams.find(team => team.id == teamId);
                    const foundTeamByName = this.teams.find(team => team.name === teamId);

                    if (!foundTeamById && !foundTeamByName) {

                        tableRow.errors.push('team_not_found');

                    } else if (foundTeamById && foundTeamByName) {

                        tableRow.errors.push('team_match_to_id_and_name');

                    } else {

                        tableRow['team_id'] = foundTeamById ? foundTeamById.id : foundTeamByName.id;
                        row['team_id'] = tableRow['team_id']; // Update the original array for postUser.

                    }
                }

                if (projectId) {
                    if (!this.projects.find(({id}) => id == projectId)) {
                        tableRow.errors.push('project_not_found');
                    }
                }

                tableRow['rowType'] = updateUser ? 'update' : 'new'

                if (!password) {
                    tableRow['password'] = username;
                }

                if (tableRow.errors.length) {
                    this.parsedFailed.push(row)
                }

                return tableRow
            });
        },
        onHeaderContextMenu() {
        },
        onRowCreate() {
            return (physicalIndex, index, row, rowData) => {
                if (rowData.errors.length) {
                    const errorField = row.querySelector('.dgtable-cell[data-column=errors]');
                    return errorField.classList.add('alert');
                }
                if (rowData.result) {
                    row.classList.add('success');
                }

            }
        },
        onHeaderRowCreate(newFunc, oldFunc) {
        },
        readyToImport() {
            return this.importData.filter(row =>
                !this.importFailed.includes(row) &&
                !this.imported.includes(row) &&
                !this.parsedFailed.includes(row)
            )
        },
    }
}

</script>
<style lang="scss">
.errors {
    color: red;
}
.row {
    display: flex;
    flex-direction: column;
}
.col {
    margin-left: 5px;
    margin-right: 5px;
    margin-bottom: 5px;
    display: flex;
    span {
        margin-right: 5px;
    }
}
</style>
